import { ChevronDown, ChevronLeft, ChevronUp, ScanLine, Star } from "lucide-react";
import { progress, type DemoScene } from "./demoScenario";
import { FocusTrace } from "./FocusTrace";

type Props = { scene: DemoScene; time: number; still: boolean };

export function RestaurantMenu() {
  return <div className="nd-menu-paper"><span>THE GARDEN TABLE</span><h4>Dinner menu</h4><p>Fresh ingredients. Simply cooked.</p>
    <div><strong>Grilled salmon</strong><span>New potatoes, seasonal vegetables,<br />lemon butter sauce</span></div>
    <div><strong>Wild mushroom pasta</strong><span>Tagliatelle, cream, parmesan</span></div>
    <div><strong>Roast chicken</strong><span>Fries, garden salad, herb dressing</span></div>
    <div><strong>Garden salad</strong><span>Mixed greens, tomatoes,<br />cucumber, house dressing</span></div>
  </div>;
}

function Header() {
  return <div className="nd-native-header"><div className="nd-back"><ChevronLeft /></div><h3>Scan a Menu</h3></div>;
}

export function MenuAnalysis(props: Props) {
  const amount = progress(props.time, props.scene.start, props.scene.end - props.scene.start);
  return <><Header /><div className="nd-deep-body nd-menu-analysis"><div className="nd-analysis-canvas">
    <div className="nd-analysis-photo"><RestaurantMenu /><div className="nd-scan-line" style={{ top: `${10 + amount * 80}%` }} /></div>
    <div className="nd-analysis-progress"><ScanLine /><h4>Reading the menu</h4><p>Finding dishes that fit your needs</p><div className="nd-loading-track"><span style={{ transform: `scaleX(${amount})` }} /></div></div>
  </div></div></>;
}

export function MenuResult(props: Props) {
  const expanded = props.scene.complete;
  return <><Header /><div className="nd-deep-body nd-menu-results">
    <div className="nd-menu-best"><Star /><h4>Best Choices</h4></div>
    <p className="nd-menu-context">You’re low in protein today.</p>
    <div className="nd-card nd-menu-recommendation">
      <FocusTrace {...props} target="menu-choice" className="nd-menu-choice"><div><strong>Grilled salmon</strong><span>Protein to help reach your target</span></div>{expanded ? <ChevronUp /> : <ChevronDown />}</FocusTrace>
      {expanded ? <div className="nd-menu-customize"><p>Order it like this</p><h4>Grilled salmon,<br />extra vegetables,<br />sauce on the side.</h4><div><strong>Extra vegetables</strong><span>Add fiber to your meal.</span></div><div><strong>Sauce on the side</strong><span>Choose how much butter and salt to add.</span></div></div> : null}
    </div>
    <div className="nd-card nd-menu-alternative"><strong>Roast chicken</strong><span>Another protein-rich option</span><ChevronDown /></div>
  </div></>;
}
